import { render } from "./dialog.vue?vue&type=template&id=a16e47e8&scoped=true"
import script from "./dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog.vue?vue&type=script&setup=true&lang=js"

import "./dialog.vue?vue&type=style&index=0&id=a16e47e8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a16e47e8"],['__file',"resources/js/v2/components/dialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a16e47e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a16e47e8', __exports__)) {
    console.log('reload')
    api.reload('a16e47e8', __exports__)
  }
  
  module.hot.accept("./dialog.vue?vue&type=template&id=a16e47e8&scoped=true", () => {
    console.log('re-render')
    api.rerender('a16e47e8', render)
  })

}


export default __exports__